<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row>
      <b-col>
        <b-form novalidate @submit.prevent="guardar()">
          <b-card
              header="Datos de la cuenta"
              header-tag="header"
              title=""
              align="left"
          >
            <b-card-body>
              <b-card-text></b-card-text>
              <b-row>
                <b-col>
                  <b-form-group label="Canal* (Tipo de empresa)" label-for="tipo">
                    <b-form-select
                        :options="lstEmpresaTipo"
                        id="tipo"
                        v-model="$v.empresa.tipo.$model"
                        required
                        :state="validateState('tipo')"
                        aria-describedby="error-tipo"
                    >
                    </b-form-select>
                    <b-form-invalid-feedback id="error-tipo"
                    >El canal es requerido
                    </b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                      label="Nombre comercial* "
                      label-for="nombre-comercial"
                  >
                    <b-form-input
                        id="nombre-comercial"
                        name="nombre_comercial"
                        v-model="$v.empresa.nombreComercial.$model"
                        required
                        aria-describedby="error-nombre-comercial"
                        :state="validateState('nombreComercial')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="error-nombre-comercial"
                    >El nombre comercial es requerido
                    </b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="R.F.C*" label-for="rfc">
                    <b-form-input
                        id="rfc"
                        v-model="$v.empresa.rfc.$model"
                        required
                        aria-describedby="error-rfc"
                        :state="validateState('rfc')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="error-rfc"
                    >El RFC es requerido
                    </b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Razón social*" label-for="razon-social">
                    <b-form-input
                        id="razon-social"
                        v-model="$v.empresa.razonSocial.$model"
                        required
                        aria-describedby="error-razon-social"
                        :state="validateState('razonSocial')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="error-razon-social"
                    >La razón social es requerida
                    </b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>

          <b-card
              header="Logo"
              header-tag="header"
              title=""
              align="left"
          >
            <b-card-body>
              <b-card-text></b-card-text>
              <div style="text-align: center" v-if="logoBase64!= null && agregarLogo === false">
                <b-button variant="outline-primary" @click="editarLogo">Editar</b-button>
                <br>
                <img alt="img" class="mt-3" :src="'data:image/png;base64,'+logoBase64.base64">
              </div>

              <b-row v-if="agregarLogo === true">
                <b-col cols="9">
                  <b-form-group
                      description="Debe escoger una imagen .png, máximo de 1Mb."
                  >
                    <b-form-file
                        v-model="$v.empresa.logo.$model"
                        placeholder="Elige una imagen o arrastra aquí..."
                        drop-placeholder="Arrastra la imagen aquí..."
                        browse-text="Buscar"
                        accept=".jpg, .png"
                    ></b-form-file>
                  </b-form-group>

                </b-col>
                <b-col>
                  <b-button v-if="agregarLogo === true && logoBase64 !== undefined && logoBase64 !== null"
                            variant="outline-danger" @click="editarLogo">Cancelar
                  </b-button>
                </b-col>
              </b-row>


            </b-card-body>
          </b-card>

          <b-card
              v-if="empresaActual != null"
              header="Configuración para Portal en linea"
              header-tag="header"
              title=""
              align="left"
          >
            <b-card-body>
              <portalLinea :idEmpresa="this.empresa.idEmpresa"/>
            </b-card-body>
          </b-card>

          <b-card
              header="Grupo empresa"
              header-tag="header"
              title="" align="left">
            <b-card-body>
              <b-row>
                <!--     <b-col>-->
                <!--        <b-form-group label="Broker" label-for="broker">-->
                <!--          <b-form-select :options="lstEmpresaBroker" name="broker" id="broker" v-model="$v.empresa.broker.$model" :state="validateState('broker')" aria-describedby="error-broker">-->
                <!--          </b-form-select>-->
                <!--          <b-form-invalid-feedback id="error-broker">El broker es requerido</b-form-invalid-feedback>-->
                <!--        </b-form-group>-->
                <!--      </b-col>-->
                <b-col>
                  <b-form-group label-for="grupo" label="Grupo">
                    <b-form-select name="grupo" :options="LstEmpresaGrupo" id="grupo" v-model="$v.empresa.grupo.$model"
                                   :state="validateState('grupo')" aria-describedby="error-grupo">
                    </b-form-select>
                    <b-form-invalid-feedback id="error-tipo">El grupo es requerido</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <!--      <b-col>-->
                <!--        <b-form-group label="Aseguradora" label-for="aseguradora">-->
                <!--          <b-form-select :options="lstEmpresaAseguradora"  name="aseguradora" id="aseguradora" v-model="$v.empresa.aseguradora.$model" :state="validateState('aseguradora')" aria-describedby="error-aseguradora">-->
                <!--          </b-form-select>-->
                <!--          <b-form-invalid-feedback id="error-aseguradora">La aseguradora es requerida</b-form-invalid-feedback>-->
                <!--        </b-form-group>-->
                <!--      </b-col>-->
              </b-row>
              <!--    <b-row>-->
              <!--      <b-col>-->
              <!--        <b-form-group label-for="corporativo" label="Corporativo">-->
              <!--          <b-form-select :options="lstEmpresaCorporativo" name="corporativo" id="corporativo" v-model="$v.empresa.corporativo.$model" :state="validateState('corporativo')" aria-describedby="error-corporativo">-->
              <!--          </b-form-select>-->
              <!--          <b-form-invalid-feedback id="error-corporativo">El corporativo es requerido</b-form-invalid-feedback>-->
              <!--        </b-form-group>-->
              <!--      </b-col>-->
              <!--      <b-col>-->
              <!--        <b-form-group label="Empresa" label-for="empresa">-->
              <!--          <b-form-select :options="lstEmpresaEmpresa" name="empresa" id="empresa" v-model="$v.empresa.empresa.$model" :state="validateState('empresa')" aria-describedby="error-empresa">-->
              <!--          </b-form-select>-->
              <!--          <b-form-invalid-feedback id="error-empresa">La empresa es requerido</b-form-invalid-feedback>-->
              <!--        </b-form-group>-->
              <!--      </b-col>-->
              <!--    </b-row>-->
            </b-card-body>
          </b-card>

          <b-card
              header="Dirección de la compania"
              header-tag="header"
              title=""
              align="left"
          >
            <b-card-body>
              <b-row>
                <b-col>
                  <b-form-group label-for="calle" label="Calle*">
                    <b-form-input
                        id="calle*"
                        name="calle"
                        v-model="$v.empresa.calle.$model"
                        required
                        aria-describedby="error-nombre-calle"
                        :state="validateState('calle')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="error-calle"
                    >La calle es requerida
                    </b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Numero*" label-for="numero">
                    <b-form-input
                        id="numero"
                        v-model="$v.empresa.numero.$model"
                        required
                        aria-describedby="error-numero"
                        :state="validateState('numero')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="error-numero"
                    >El número es requerido
                    </b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label-for="colonia" label="Colonia*">
                    <b-form-select
                        :options="lstLocalidades"
                        name="colonia"
                        id="colonia"
                        v-model="empresa.colonia"
                        aria-describedby="error-colonia"
                        :disabled="blnSelectLocalidad"
                    >
                    </b-form-select>
                    <b-form-invalid-feedback id="error-colonia"
                    >La colonia es requerido
                    </b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="C.P*" label-for="cp">
                    <b-form-input
                        v-on:keyup="obtenerLocalidades(empresa.codigoPostal)"
                        id="cp"
                        v-model="$v.empresa.codigoPostal.$model"
                        required
                        aria-describedby="error-cp"
                        :state="validateState('codigoPostal')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="error-cp"
                    >El código postal es requerido
                    </b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label-for="estado" label="Estado*">
                    <b-form-select
                        :options="lstEstados"
                        name="estado"
                        id="estado"
                        v-model="$v.empresa.estado.$model"
                        :state="validateState('estado')"
                        aria-describedby="error-colonia"
                        disabled
                    >
                    </b-form-select>
                    <b-form-invalid-feedback id="error-estado"
                    >La colonia es requerido
                    </b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label-for="pais" label="Pais*">
                    <b-form-select
                        :options="lstPais"
                        name="pais"
                        id="pais"
                        v-model="$v.empresa.pais.$model"
                        :state="validateState('pais')"
                        aria-describedby="error-pais"
                        disabled
                    >
                    </b-form-select>
                    <b-form-invalid-feedback id="error-pais"
                    >El pais es requerido
                    </b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
          <b-card
              header="Informacion de contacto"
              header-tag="header"
              title=""
              align="left"
          >
            <b-card-body>
              <b-row v-for="(contacto, index) in empresa.contacto" :key="index">
                <b-col>
                  <b-form-group label="Nombre" :label-for="'cnombre_' + index">
                    <b-form-input
                        :id="'cnombre_' + index"
                        v-model="contacto.nombre"
                        aria-describedby="error-cnombre"
                    ></b-form-input>
                    <b-form-invalid-feedback id="error-cnombre"
                    >El nombre es requerido
                    </b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                      label="Télefono "
                      :label-for="'ctelefono_' + index"
                  >
                    <b-form-input
                        :id="'ctelefono_' + index"
                        v-model="contacto.telefono"
                        :state="validateState('telefono')"
                        aria-describedby="error-ctelefono"
                    ></b-form-input>
                    <b-form-invalid-feedback id="error-ctelefono"
                    >El télefono es requerido
                    </b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                      label="Extensión"
                      :label-for="'cextension_' + index"
                  >
                    <b-form-input
                        :id="'cextension_' + index"
                        v-model="contacto.extension"
                        :state="validateState('extension')"
                        aria-describedby="error-cextension"
                    ></b-form-input>
                    <b-form-invalid-feedback id="error-cextension"
                    >La extensión es requerido
                    </b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Correo" :label-for="'ccorreo_' + index">
                    <b-form-input
                        :id="'ccorreo_' + index"
                        type="email"
                        v-model="contacto.correo"
                        :state="validateState('correo')"
                        aria-describedby="error-cextension"
                    ></b-form-input>
                    <b-form-invalid-feedback id="error-ccorreo"
                    >El correo es requerido
                    </b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-button
                      variant="outline-danger"
                      v-on:click="quitarContacto(index)"
                  >Eliminar
                  </b-button
                  >
                </b-col>
                <br/>
              </b-row>
              <b-row>
                <b-col align="left">
                  <b-button
                      variant="outline-success"
                      v-on:click="agregarContacto()"
                  >Agregar
                  </b-button
                  >
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
          <b-row class="mt-4">
            <b-col align="right">
              <b-button class="mr-4" variant="outline-primary" type="submit"
              >Guardar
              </b-button
              >
              <b-button variant="outline-danger" v-on:click="cerrar()"
              >Cancelar
              </b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import portalLinea from "@/components/empresas/PortalLineaEmpresas.vue";
import {required} from "vuelidate/lib/validators";
import {EmpresaService} from "@/apiServices/empresa/EmpresaService";

export default {
  name: "form-empresas",
  components: {
    portalLinea,
  },
  props: {
    empresaActual: null,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    empresaService: new EmpresaService(),
    options: [
      {id: 1, value: 1, text: "Tipo A"},
      {id: 2, value: 2, text: "Tipo B"},
    ],
    blnSelectLocalidad: true,
    controladorTiempo: null,
    lstPais: [],
    lstEstados: [],
    lstLocalidades: [],
    lstEmpresaEmpresa: [],
    lstEmpresaAseguradora: [],
    lstEmpresaCorporativo: [],
    lstEmpresaBroker: [],
    lstEmpresaTipo: [],
    LstEmpresaGrupo: [],
    empresa: {
      idEmpresa: null,
      tipo: 0,
      nombreComercial: "",
      rfc: "",
      razonSocial: "",
      broker: 0,
      grupo: "",
      aseguradora: "",
      corporativo: "",
      empresa: "",
      calle: "",
      numero: "",
      colonia: "",
      codigoPostal: "",
      estado: "",
      pais: "",
      contacto: [
        {
          id: null,
          nombre: "",
          telefono: "",
          extension: "",
          correo: "",
        },
      ],
      idUsuario: null,
      logo: null,
    },
    lstEmpresas: [],
    hoy: null,
    logoBase64: null,
    agregarLogo: true,
  }),
  validations: {
    empresa: {
      tipo: {required},
      nombreComercial: {required},
      rfc: {required},
      razonSocial: {required},
      broker: {},
      grupo: {},
      aseguradora: {},
      corporativo: {},
      empresa: {},
      calle: {required},
      numero: {required},
      //colonia: { required },
      estado: {required},
      pais: {required},
      codigoPostal: {required},
      nombre: {},
      telefono: {},
      extension: {},
      correo: {},
      logo: {}
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.hoy = this.$moment().format("DD-MM-YYYY");
    if (this.empresaActual !== null) {
      this.empresa = this.empresaActual;
      this.obtenerLocalidades(this.empresa.codigoPostal);
      this.obtenerLogo(this.empresa.idEmpresa);
    }
    this.obtenerEmpresaTipo();
    this.obtenerEmpresaGrupo();
    this.obtenerEmpresaBroker();
    this.obtenerEmpresaCorporativo();
    this.obtenerEmpresaAseguradora();
    this.obtenerEmpresaEmpresa();
  },
  methods: {
    editarLogo() {
      this.agregarLogo = !this.agregarLogo;
    },
    async obtenerLogo(idEmpresa) {
      const parametros = {idEmpresa: idEmpresa}
      this.empresaService.getLogoConBase64(parametros).then(logo => {
        this.logoBase64 = logo
        if (logo.base64 !== undefined && logo.base64 !== null) {
          this.agregarLogo = false;
        }
      })
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    /**
     * Funcion para abrir formulario
     */ async guardar() {
      this.$v.empresa.$touch();
      if (this.$v.empresa.$anyError) {
        this.$bvToast.toast('No se puede guardar', {headerClass: 'bg-danger'});
        return;
      }
      if (!this.$v.empresa.$invalid) {

        if (this.empresa.logo !== null) {
          if (this.empresa.logo.size > 1024000) {
            this.$bvToast.toast('No se puede guardar, la imagen es muy pesada. ', {headerClass: 'bg-danger'});
            return;
          } else {
            this.empresa.extension = this.empresa.logo.type;
            let logoBase64 = await this.getBase64(this.empresa.logo);
            let indexComa = logoBase64.indexOf(',', 0)
            let indice = logoBase64.slice(indexComa + 1);
            this.empresa.logo = indice;
          }
        }

        this.empresa.idUsuario = this.$localStorageService.getIdUsuario();
        this.$http
            .post(this.$api + "empresas/guardar", this.empresa)
            .then((response) => {
              if (response.data.data) {
                this.$emit("guardar", this.empresa);
              }
            })
            .catch(function (error) {
              console.error(error);
            });
      }
    },
    /**
     * Funcion para cerrar formulario
     */
    cerrar() {
      this.$emit("speak", "cerrar");
    },
    /**
     * Validaciones para los campos
     * @param fieldName
     * @returns {{"md-invalid": (boolean|(function(): (boolean|*))|(function(): (boolean|*))|Ref<Boolean>|Boolean)}}
     */
    getValidationClass(fieldName) {
      const field = this.$v.empresa[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    /**
     * Funcion para validar formulario bootstrap vue
     */
    validateState(name) {
      const {$dirty, $error} = this.$v.empresa[name];
      return $dirty ? !$error : null;
    },
    /**
     * Funcion para quitar contacto
     */
    quitarContacto(index) {
      this.empresa.contacto.splice(index, 1);
    },
    /**
     * Funcion para agregar más contactos
     */
    agregarContacto() {
      this.empresa.contacto.push({
        id: 0,
        nombre: "",
        telefono: "",
        extension: 0,
        correo: "",
      });
    },
    /**
     * Funcion para ontener el tipo de la empresa
     */
    obtenerEmpresaTipo() {
      this.lstEmpresaTipo.push({
        value: null,
        text: "No hay datos...",
        disabled: true,
      });
      this.$http
          .get(this.$api + "catalogos/empresatipo")
          .then((response) => {
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstEmpresaTipo = [];
              this.lstEmpresaTipo.push({
                value: null,
                text: "Seleccione una opción",
                disabled: true,
              });
              resultado.forEach((item) => {
                this.lstEmpresaTipo.push({
                  value: item.idEmpresaTipo,
                  text: item.nombreTipo,
                });
              });
            }
          })
          .catch(function (error) {
            console.error(error);
          });
    },
    /**
     * Funcion para obtener el grupo  de la empresa
     */
    obtenerEmpresaGrupo() {
      this.$http
          .get(this.$api + "catalogos/empresagrupo")
          .then((response) => {
            if (response.data.data) {
              let resultado = response.data.data;
              this.LstEmpresaGrupo = [];
              this.LstEmpresaGrupo.push({
                value: null,
                text: "Seleccione una opción",
                disabled: true,
              });
              resultado.forEach((item) => {
                this.LstEmpresaGrupo.push({
                  value: item.idEmpresaGrupo,
                  text: item.nombreGrupo,
                });
              });
              if (resultado.length === 0) {
                this.LstEmpresaGrupo.push({
                  value: null,
                  text: "No hay datos...",
                  disabled: true,
                });
              }
            }
          })
          .catch(function (error) {
            console.error(error);
          });
    },
    /**
     * Servicio para obtener el broker de la empresa
     */
    obtenerEmpresaBroker() {
      const parametros = {idTipoEmpresa: 3}
      this.$http
          .post(this.$api + "catalogos/empresabroker", parametros)
          .then((response) => {
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstEmpresaBroker = [];
              this.lstEmpresaBroker.push({
                value: null,
                text: "Seleccione una opción",
                disabled: true,
              });
              resultado.forEach((item) => {
                this.lstEmpresaBroker.push({
                  value: item.idEmpresa,
                  text: item.nombreEmpresa,
                });
              });
              if (resultado.length === 0) {
                this.lstEmpresaBroker.push({
                  value: null,
                  text: "No hay datos...",
                  disabled: true,
                });
              }
            }
          })
          .catch(function (error) {
            console.error(error);
          });
    },
    /**
     * Funcion para ontener el corporativo
     */
    obtenerEmpresaCorporativo() {
      const parametros = {idTipoEmpresa: 5}
      this.$http
          .post(this.$api + "catalogos/empresacorporativo", parametros)
          .then((response) => {
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstEmpresaCorporativo = [];
              this.lstEmpresaCorporativo.push({
                value: null,
                text: "Seleccione una opción",
                disabled: true,
              });
              resultado.forEach((item) => {
                this.lstEmpresaCorporativo.push({
                  value: item.idEmpresa,
                  text: item.nombreEmpresa,
                });
              });
              if (resultado.length === 0) {
                this.lstEmpresaCorporativo.push({
                  value: null,
                  text: "No hay datos...",
                  disabled: true,
                });
              }
            }
          })
          .catch(function (error) {
            console.error(error);
          });
    },
    /**
     * Funcion para ontener el corporativo
     */
    obtenerEmpresaAseguradora() {
      const parametros = {idTipoEmpresa: 2}
      this.$http
          .post(this.$api + "catalogos/empresacorporativo", parametros)
          .then((response) => {
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstEmpresaAseguradora = [];
              this.lstEmpresaAseguradora.push({
                value: null,
                text: "Seleccione una opción",
                disabled: true,
              });
              resultado.forEach((item) => {
                this.lstEmpresaAseguradora.push({
                  value: item.idEmpresa,
                  text: item.nombreEmpresa,
                });
              });
              if (resultado.length === 0) {
                this.lstEmpresaAseguradora.push({
                  value: null,
                  text: "No hay datos...",
                  disabled: true,
                });
              }
            }
          })
          .catch(function (error) {
            console.error(error);
          });
    },
    /**
     * Funcion para obtener el tipo empresa
     */
    obtenerEmpresaEmpresa() {
      const parametros = {idTipoEmpresa: 1}
      this.$http
          .post(this.$api + "catalogos/empresacorporativo", parametros)
          .then((response) => {
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstEmpresaEmpresa = [];
              this.lstEmpresaEmpresa.push({
                value: null,
                text: "Seleccione una opción",
                disabled: true,
              });
              resultado.forEach((item) => {
                this.lstEmpresaEmpresa.push({
                  value: item.idEmpresa,
                  text: item.nombreEmpresa,
                });
              });
              if (resultado.length === 0) {
                this.lstEmpresaEmpresa.push({
                  value: null,
                  text: "No hay datos...",
                  disabled: true,
                });
              }
            }
          })
          .catch(function (error) {
            console.error(error);
          });
    },
    /**
     *Buscar localidades con el codigo postall
     */
    obtenerLocalidadByCP(codigoPostal) {
    const parametros = {codigoPostal: codigoPostal}
      this.$http
          .post(
              this.$api + "catalogos/localidadesbycp", parametros
          )
          .then((response) => {
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstLocalidades = [];
              this.lstEstados = [];
              this.lstPais = [];
              this.lstLocalidades.push({
                value: null,
                text: "Seleccione una opción",
                disabled: true,
              });
              resultado.forEach((item) => {
                this.lstLocalidades.push({
                  value: item.descripcion,
                  text: item.descripcion,
                  codigoPostal: item.codigoPostal,
                });
                if (this.lstEstados.length === 0) {
                  this.lstEstados.push({
                    value: item.nombre,
                    text: item.nombre,
                    selected: true,
                  });
                  this.lstPais.push({
                    value: item.pais,
                    text: item.pais,
                    selected: true,
                  });
                  this.empresa.estado = item.nombre;
                  this.empresa.pais = item.pais;
                }
              });
              if (resultado.length === 0) {
                this.blnSelectLocalidad = true;
                this.empresa.colonia = null;
              } else {
                this.blnSelectLocalidad = false;
              }
            }
          })
          .catch(function (error) {
            console.error(error);
          });
    },
    /**
     * Funcionalidad de obtener el cp que se teclea con filtro para solo numeros
     * y retardo de tiempo para esperar que termine el usuario de escribir
     * @param codigoPostal
     */
    obtenerLocalidades(codigoPostal) {
      clearTimeout(this.controladorTiempo);
      this.controladorTiempo = setTimeout(() => {
        this.obtenerLocalidadByCP(codigoPostal.replace(/[^0-9 ]/g, ""));
        clearTimeout(this.controladorTiempo);
      }, 1000);
    },
    imagetoBlob(image) {
      return new Blob([image], {type: image.type});
    }

  },
};
</script>
